<template>
  <div style="display: inline">
    <el-dropdown style="width: 4rem" v-show="items != 0" @command="handleCommand">
      <el-button type="text">
        <i class="el-icon-download"></i>
      </el-button>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item command="exportexcel">下载表格数据</el-dropdown-item>
        <el-dropdown-item command="getchartparams" v-show="roles.includes('admin')">获取数图配置</el-dropdown-item>
        <el-dropdown-item command="exportchartdata" v-show="$store.getters.showchart">下载图表数据</el-dropdown-item>
        <el-dropdown-item command="dbtoexcel" v-show="roles.includes('admin')">下载完整数据库数据</el-dropdown-item>
        <el-dropdown-item command="splitfield" v-show="roles.includes('superadmin')">生成分裂汇总数据</el-dropdown-item>
        <el-dropdown-item command="tomodify" v-show="roles.includes('superadmin')">批量更改数据</el-dropdown-item>
        <el-dropdown-item command="thedatatopdf"
          v-show="roles.includes('superadmin') && $store.state.collection.pdf">下载数据库pdf</el-dropdown-item>
        <el-dropdown-item command="combinefield" v-show="roles.includes('superadmin')">下载合并数据</el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>

    <!-- 数图参数 -->
    <el-dialog width="80%" title="当前参数" :visible.sync="showchartparams">
            <el-input type="textarea" autosize placeholder="Please input" v-model="chartparams" clearable>
            </el-input>
        </el-dialog>

    <!-- 下载分裂数据 -->
    <el-dialog fullscreen @close="resetsplit" :visible.sync="splitfielddialog">
      <tosplitfield ref="tosplitfield"></tosplitfield>
    </el-dialog>
    <!-- 批量更改数据 -->
    <el-dialog fullscreen :visible.sync="tomodifydialog">
      <tomodify @done="tomodifydialog = false"></tomodify>
    </el-dialog>
    <!-- 下载合并数据 -->
    <el-dialog fullscreen @close="
      combinefixed = [];
    combinetarget = [];
                                    " :visible.sync="combinefielddialog">
      <p>选择需要合并的field,作为新的field</p>
      <el-checkbox-group v-model="combinetarget" :min="1">
        <el-checkbox v-for="x in fields" :label="x.name" :key="x.name">{{
          x.title
        }}</el-checkbox>
      </el-checkbox-group>

      <p>选择固定fields,作为列</p>
      <el-checkbox-group v-model="combinefixed">
        <el-checkbox v-for="x in fields" :label="x.name" :key="x.name">{{
          x.title
        }}</el-checkbox>
      </el-checkbox-group>

      <el-button @click="combinefield">确认</el-button>
    </el-dialog>
  </div>
</template>
<script>
import { chartdataxy, itemscollection } from "@/components/utility/indexdb";

import tomodify from "./tomodify";
import tosplitfield from "./tosplitfield"
import jsontoexcel from "js-export-excel";
import {tomakeurl,getparamsfromstore} from "@/axios/objparamobj"
// import {getparamsfromstore} from "../../../axios/objparamobj"
export default {
  components: { tomodify, tosplitfield },
  data() {
    return {
      splitfielddialog: false,
      combinefielddialog: false,
      tomodifydialog: false,
      showchartparams:false,

      chartparams:"",
      combinetarget: [],
      combinefixed: [],
    };
  },
  computed: {

    roles() {
      return this.$store.state.roles;
    },
    items() {
      return this.$store.state.items;
    },
    thecollection() {
      return this.$store.state.collection.value;
    },
    fields() {
      return this.$store.state.currentheader;
    },
    // pipe() {
    //   return this.$store.getters.fieldtype;
    // },
    targettxt() {
      return this.$store.state.targettxt;
    },
    filter() {
      return this.$store.state.filter;
    },
    xfield() {
      return this.$store.state.xfield;
    },
    yvalues() {
      return this.$store.state.yvalues;
    },
  },
  methods: {
    handleCommand(command) {
      switch (command) {
        case "getchartparams":
          this.togetchartparams();
          break;
        case "exportexcel":
          this.exportexcel();
          break;
        case "thedatatopdf":
          this.thedatatopdf();
          break;
        case "exportchartdata":
          this.exportchartdata();
          break;
        case "dbtoexcel":
          this.dbtoexcel();
          break;
        case "splitfield":
          this.splitfielddialog = true;
          break;
        case "combinefield":
          this.combinefielddialog = true;
          break;
        case "tomodify":
          this.tomodifydialog = true;
          break;
      }
    },

    togetchartparams(){
      let chartparams=getparamsfromstore("chartparams")
      let dataurl=tomakeurl(chartparams, this.$store.state.searchmodel)
      chartparams.dataurl=dataurl
      this.chartparams=JSON.stringify(chartparams, null, 4)
      this.showchartparams=true
    },

    resetsplit() {
      this.$refs.tosplitfield.resetsplit()
    },
    exportexcel() {
      this.$prompt("请为文件命名", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
      }).then(({ value }) => {
        itemscollection.find().toArray((err, docs) => {
          let excelfields = [];
          let exceltitles = [];
          this.fields.forEach((obj) => {
            excelfields.push(obj.name);
            exceltitles.push(obj.title);
          });
          let option = {};

          option.fileName = value; //以prompt的值为文件命名

          option.datas = [
            {
              sheetData: docs,
              sheetName: "Sheet1",
              sheetFilter: excelfields,
              sheetHeader: exceltitles,
              //columnWidths: [20, 20]
            },
          ];

          let toExcel = new jsontoexcel(option); //new
          toExcel.saveExcel(); //保存
        });
      });
    },

    exportchartdata() {
      let fields = [];
      let header = [];
      this.fields.forEach((obj) => {
        if (
          this.$store.state.xfield === obj.name ||
          this.$store.state.yvalues.includes(obj.name)
        ) {
          fields.push(obj.name);
          header.push(obj.title);
        }
      });
      let option = {
        fileName: "图表数据",
        datas: [
          {
            //sheetData: docs,
            sheetName: "sheet",
            sheetFilter: fields,
            sheetHeader: header,
          },
        ],
      };

      option.datas[0].sheetData = this.$store.state.chartdataxy;
      let toExcel = new jsontoexcel(option); //new
      toExcel.saveExcel();
    },

    dbtoexcel() {
      this.$prompt("请输入验证码", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
      }).then(({ value }) => {
        let query = getparamsfromstore(this.$store.state.searchmodel)
        query.downloadcode=value
        query.searchmodel=this.$store.state.searchmodel
        // let query = {
        //   matchrule: this.$store.state.matchrule,
        //   downloadcode: value,
        //   searchmodel: this.$store.state.searchmodel,
        //   collection: this.thecollection,
        //   target: this.targettxt, //for generalsearch
        //   fdata: this.filter, //for filter
        //   ids: this.$store.state.fetchids, //for fetchbyids
        // };

        // console.log(query)
        this.$axios
          .post(url + "dbtoexcel", query, {
            responseType: "blob",
          })
          .then((res) => {
            if (res.data.type === "text/html") {
              this.$message("验证码错误");
              return;
            }
            let src = URL.createObjectURL(res.data);
            let link = document.createElement("a");
            link.download = this.thecollection + ".xlsx";
            link.href = src;
            link.click();
          });
      });
    },
    thedatatopdf() {
      this.$confirm("可下载200个数据库数据为pdf", "Warning", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$axios.thedatatopdf();
          // this.$message({
          //   type: 'success',
          //   message: ''
          // });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "取消",
          });
        });
    },



    combinefield() {
      if (this.combinetarget.length < 1 || this.combinefixed.length < 1) {
        this.$message("请完成选择");
        return;
      }

      this.combinefielddialog = false;

      let query = {
        collection: this.thecollection,
        fdata: this.filter,
        pipe: this.pipe,
        combinetarget: this.combinetarget,
        combinefixed: this.combinefixed,
      };
      this.$axios
        .post(url + "combinefield", query, { responseType: "blob" })
        .then((res) => {
          // this.splitfixed = [];
          // this.splittarget = [];
          // this.sumitem = [];

          let src = URL.createObjectURL(res.data);
          let link = document.createElement("a");
          link.download = this.thecollection + "合并表.xlsx";
          link.href = src;
          link.click();
        });
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/presentation/table/download.vue